export enum PixTypes {
	cpf = "cpf",
	cnpj = "cnpj",
	email = "email",
	phone = "phone",
	random = "random"
}
